import { PropertyMapping, propertyMapping, required } from '@hakla/typed-forms'
import { ResourceViewModel } from '@/business/resource/interfaces/resource-view-model'

export interface RenameResourceForm {
  description: string
  name: string
}

export function renameResourceFormMapping(): PropertyMapping<
  ResourceViewModel,
  RenameResourceForm
> {
  return propertyMapping(({ generic }) => {
    return {
      description: generic('description'),
      name: generic('name').validations(required),
    }
  })
}
